
<template>
  <div class="page-wrap">
    <ul>
      <li v-for="i, index in showPageBtn" :key="index"
        :class="{ active: i === currentPage, pointer: i, hover: i && i !== currentPage }" @click="pageOffset(i)">
        <a v-if="i" class="notPointer">{{ i }}</a>
        <a v-else>···</a>
      </li>
    </ul>
    <!-- <ul v-show="prePage" class="li-page" @click="goPrePage">上一页</ul> -->

    <ul v-show="prePage" class="container-item-5 li-page pointer"  @click="goPrePage">
      <img class="dot-11" src="@/assets/img/news/images/img_20.png" />
    </ul>

    <ul class="container-item-5 li-page pointer"  v-show="nextPage" @click="goNextPage">
      <img class="dot-11" src="@/assets/img/news/images/img_21.png" />
    </ul>
    <!-- <ul v-show="nextPage" class="li-page" @click="goNextPage">下一页</ul> -->
  </div>
</template>

<script>
export default {
  props:{
    num:{
      type: Number,
      default: 7,
    }
  },
  data () {
    return {
      limit: 1,
      offset: 0
    }
  },

  computed: {
    prePage () {
      return this.offset !== 0 && this.num
    },

    nextPage () {
      return (this.offset + this.limit < this.num) && this.num
    },

    totalPage () {
      return Math.ceil(this.num / this.limit)
    },

    currentPage () {
      return Math.ceil(this.offset / this.limit) + 1
    },

    showPageBtn () {
      const pageNum = this.totalPage
      const index = this.currentPage
      if (pageNum <= 5) return [...new Array(pageNum)].map((v, i) => i + 1)
      if (index <= 2) return [1, 2, 3, 0, pageNum]
      if (index >= pageNum - 1) return [1, 0, pageNum - 2, pageNum - 1, pageNum]
      if (index === 3) return [1, 2, 3, 4, 0, pageNum]
      if (index === pageNum - 2) return [1, 0, pageNum - 3, pageNum - 2, pageNum - 1, pageNum]
      return [1, 0, index - 1, index, index + 1, 0, pageNum]
    }
  },

  methods: {
    pageOffset (i) {
      if (i === 0 || i === this.currentPage) return
      this.offset = (i - 1) * this.limit
      this.$emit('getNew', this.offset)
    },

    goPrePage () {
      this.offset -= this.limit
      this.$emit('getNew', this.offset)
    },

    goNextPage () {
      this.offset += this.limit
      this.$emit('getNew', this.offset)
    }
  }
}
</script>


<style lang="less">
.page-wrap {
  text-align: center;
  font-size: 18px;
  margin-top: 80px;
  display: flex;

  ul {
    display: inline-block;
    list-style: none;
    overflow: hidden;

    li {
      float: left;
      color: #1e5a6b;
      padding: 1px 10px;
      margin: 0 5px;
      border-radius: 50%;
      user-select: none;
      border: 1px solid transparent;
    }
  }

  .pointer {
    cursor: pointer;
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    background-clip: padding-box;
    display: flex;
    justify-content: center;
    align-self: center;
    box-sizing: border-box;
    padding: 6px 12px;
    // border: 1px solid #2db3d0;
    border: 1px solid #E4E4E4;
    border-radius: 2px;
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0em;

    a {
      color: #000000;
      opacity: 0.8;
    }

    /* 字1 */

  }

  .pointer.active {
    border: 1px solid #2db3d0;

    a {
      color: #2db3d0;
      opacity: 1;
    }
  }
  .li-page:hover{
    border-color: #2db3d0;
  }

  .hover {
    &:hover {
      border-color: #2db3d0;

      a {
        color: #2db3d0;
        opacity: 1;
      }
    }
  }

  .li-page {
    line-height: 1.5;
    cursor: pointer;
    color: #1e5a6b;

    &:hover {
      color: #7ba6b3;
    }
  }

  .active {
    border-color: #246c81;
  }

  .container-item-5 {
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    background-clip: padding-box;
    display: flex;
    margin-left: 16px;
    justify-content: flex-start;
    align-self: center;
    box-sizing: border-box;
    padding: 14px 5px;
    border: 1px solid #e4e4e4;
    border-radius: 2px;
  }

  .dot-11 {
    width: 17px;
    height: 11px;
    margin-left: 6px;
    align-self: flex-start;
  }
}</style>



// WEBPACK FOOTER //
// src/components/pagination.vue